// Login attempt tracking utility

const MAX_ATTEMPTS = 10;
const LOCKOUT_DURATION = 15 * 60 * 1000; // 15 minutes in milliseconds

export const trackLoginAttempt = (email) => {
  const now = Date.now();
  const attempts = JSON.parse(localStorage.getItem('loginAttempts') || '{}');
  
  // Clean up old attempts
  Object.keys(attempts).forEach(key => {
    if (now - attempts[key].timestamp > LOCKOUT_DURATION) {
      delete attempts[key];
    }
  });

  // Initialize or update attempt count for this email
  if (!attempts[email]) {
    attempts[email] = {
      count: 1,
      timestamp: now
    };
  } else {
    attempts[email].count += 1;
    attempts[email].timestamp = now;
  }

  localStorage.setItem('loginAttempts', JSON.stringify(attempts));
  return attempts[email];
};

export const getLoginAttempts = (email) => {
  const attempts = JSON.parse(localStorage.getItem('loginAttempts') || '{}');
  return attempts[email] || { count: 0, timestamp: 0 };
};

export const isAccountLocked = (email) => {
  const attempt = getLoginAttempts(email);
  const now = Date.now();
  
  if (attempt.count >= MAX_ATTEMPTS && 
      now - attempt.timestamp < LOCKOUT_DURATION) {
    return true;
  }
  return false;
};

export const getLockoutTimeRemaining = (email) => {
  const attempt = getLoginAttempts(email);
  const now = Date.now();
  
  if (attempt.count >= MAX_ATTEMPTS) {
    const timeRemaining = LOCKOUT_DURATION - (now - attempt.timestamp);
    if (timeRemaining > 0) {
      return Math.ceil(timeRemaining / 1000 / 60); // Convert to minutes
    }
  }
  return 0;
};

export const resetLoginAttempts = (email) => {
  const attempts = JSON.parse(localStorage.getItem('loginAttempts') || '{}');
  delete attempts[email];
  localStorage.setItem('loginAttempts', JSON.stringify(attempts));
}; 